<template>
  <div class="modal fade" id="modalChangeCode" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Alteração do Código.</h4>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>Código</label>
              <input v-model="dataChange.code" type="text" class="form-control" name="code" placeholder="Código"
                     required>
              <span v-if="errorMsg" class="error-msg">{{ errorMsg }}</span>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button v-on:click="changeCode()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CHANGE_USER_CODE
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import swal from "sweetalert";

export default {
  name: "modalChangeCode",
  props: ['dataModal'],
  data() {
    return {
      errorMsg: '',
      dataChange: {
        userId: '',
        code: ''
      },
      newUserCode: null,
      loadingChange: false
    }
  },
  watch: {
    dataModal: function (val) {
      this.dataChange.userId = val.id;
      this.dataChange.code = val.code;
    },
    newUserCode: function (val) {
      this.$emit('update:newUserCode', val)
    },
  },
  methods: {
    closeModal() {
      $('#modalChangeCode').modal('toggle');
    },
    changeCode() {
      this.errorMsg = "";
      if (this.dataChange.userId) {
        if (this.dataChange.code) {
          UTIL_SERVICE.console("DATA SEND:", this.dataChange);
          REQUEST_SERVICE.put(CHANGE_USER_CODE + "?userId=" + this.dataChange.userId + "&code=" + this.dataChange.code, '').then((response) => {
            UTIL_SERVICE.console("RESULT CHANGE_USER_CODE:", response);
            this.newUserCode = this.dataChange.code;

            $('#modalChangeCode').modal('toggle');

            ALERT_SERVICE.swal("Aviso", "Código atualizada com sucesso.", "success");
          }).catch((reason) => {
            swal({
              title: "Ops...",
              text: reason.response.data.erros[0].value,
              button: "Confirmar",
              icon: 'error'
            });

            $('#modalChangeCode').modal('toggle');
          });
        } else {
          this.errorMsg = "Preencha um código válido.";
        }
      } else {
        swal({
          title: "Ops...",
          text: "Atualize a página e tente novamente.",
          button: "Confirmar",
          icon: 'error'
        });

        $('#modalChangeCode').modal('toggle');
      }

    }
  }
}
</script>

<style lang="scss" scoped>
#modalChangeCode {
  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeCode.vue